import React from 'react';
import { LoginHeader } from '../components/LoginHeader';
import { Typography } from '@thingsw/pitta-design-system';
import { useTranslation } from 'react-i18next';
import { makeStyles, Theme } from '@material-ui/core';
import { LightColors } from '@thingsw/pitta-modules';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: LightColors.primary['0'],
    margin: '94px 16px 0',
    minHeight: 'calc(100vh - 58px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 40,
  },
}));

export const SubscriptionSuccessUseAppScreen = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <LoginHeader />
      <div className={classes.root}>
        <Typography variant='H2'>
          {t('Subscription process is complete')}
        </Typography>

        <div>
          <svg
            width='116'
            height='64'
            viewBox='0 0 116 64'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g clipPath='url(#clip0_3995_283694)'>
              <path d='M64.0625 0H0V64.0625H64.0625V0Z' fill='white' />
              <rect width='64' height='64' fill='#61007D' />
              <path
                d='M55.0273 51.384C55.1365 51.7041 55.1875 51.8933 55.1875 51.9443C55.1875 52.4245 54.9181 52.6646 54.3866 52.6646H49.9013C49.4717 52.6646 49.1513 52.4536 48.9401 52.0243L44.3747 42.4996H25.1519C24.7805 42.4996 24.5912 42.3105 24.5912 41.9394C24.5912 41.7793 24.6204 41.6483 24.6713 41.5391L26.4334 38.0174C26.6446 37.4863 27.0451 37.217 27.6348 37.217H41.8116L32.0401 16.1667L14.5794 52.0243C14.3682 52.4536 14.0478 52.6646 13.6182 52.6646H9.61348C9.08194 52.6646 8.8125 52.4245 8.8125 51.9443C8.8125 51.8933 8.86349 51.7041 8.97271 51.384L27.9552 12.8851C28.1664 12.4558 28.4722 12.0993 28.8727 11.8009C29.2732 11.5099 29.6882 11.3644 30.1178 11.3644H33.8823C34.3119 11.3644 34.7269 11.5099 35.1274 11.8009C35.5278 12.092 35.8337 12.4558 36.0521 12.8851L55.0346 51.384H55.0273Z'
                fill='white'
              />
            </g>
            <path
              d='M106 46V38C106 36.3333 105.417 34.9167 104.25 33.75C103.083 32.5833 101.667 32 100 32H81.65L88.85 39.2L86 42L74 30L86 18L88.85 20.8L81.65 28H100C102.767 28 105.125 28.975 107.075 30.925C109.025 32.875 110 35.2333 110 38V46H106Z'
              fill='#13131C'
            />
            <defs>
              <clipPath id='clip0_3995_283694'>
                <rect width='64' height='64' rx='8' fill='white' />
              </clipPath>
            </defs>
          </svg>
        </div>

        <Typography variant='H6'>
          {t(
            'Now, go back to the FLEETA app, log in to your account, and start enjoying the service.'
          )}
        </Typography>
      </div>
    </>
  );
};
